// This file is auto-generated by backstage-cli translations import
// Do not edit manually.

import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { catalogTranslationRef } from '@backstage/plugin-catalog/alpha';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react/alpha';
import { coreComponentsTranslationRef } from '@backstage/core-components/alpha';
import { notificationsTranslationRef } from '@backstage/plugin-notifications/alpha';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder/alpha';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react/alpha';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings/alpha';

export default [
  createTranslationResource({
    ref: catalogTranslationRef,
    translations: {
    "pt": () => import('./../../translations/messages/catalog.pt.json'),
    },
  }),
  createTranslationResource({
    ref: catalogReactTranslationRef,
    translations: {
    "pt": () => import('./../../translations/messages/catalog-react.pt.json'),
    },
  }),
  createTranslationResource({
    ref: coreComponentsTranslationRef,
    translations: {
    "pt": () => import('./../../translations/messages/core-components.pt.json'),
    },
  }),
  createTranslationResource({
    ref: notificationsTranslationRef,
    translations: {
    "pt": () => import('./../../translations/messages/plugin.notifications.pt.json'),
    },
  }),
  createTranslationResource({
    ref: scaffolderTranslationRef,
    translations: {
    "pt": () => import('./../../translations/messages/scaffolder.pt.json'),
    },
  }),
  createTranslationResource({
    ref: scaffolderReactTranslationRef,
    translations: {
    "pt": () => import('./../../translations/messages/scaffolder-react.pt.json'),
    },
  }),
  createTranslationResource({
    ref: userSettingsTranslationRef,
    translations: {
    "pt": () => import('./../../translations/messages/user-settings.pt.json'),
    },
  }),
];
